import { render, staticRenderFns } from "./form-queries-comment-form.vue?vue&type=template&id=1b3acb66&scoped=true&"
import script from "./form-queries-comment-form.vue?vue&type=script&lang=js&"
export * from "./form-queries-comment-form.vue?vue&type=script&lang=js&"
import style0 from "./form-queries-comment-form.vue?vue&type=style&index=0&id=1b3acb66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3acb66",
  null
  
)

component.options.__file = "form-queries-comment-form.vue"
export default component.exports